<template>
    <button :disabled="isStateLoading" @click.stop.prevent="$emit('click', $event)" class="position-relative">
        <span
            v-if="isStateLoading"
            class="position-absolute d-flex top-0 left-0 h-100 w-100 align-items-center justify-content-center"
        >
            <i class="fa fa-spin btn-loading-animation"></i>
        </span>

        <span v-if="icon && !showIconAfterText" :class="{ 'opacity-0': isStateLoading }">
            <i :class="icon"></i>
        </span>

        <span :class="{ 'opacity-0': isStateLoading }">
            {{ text }}
        </span>

        <span v-if="icon && showIconAfterText" :class="{ 'opacity-0': isStateLoading }">
            <i :class="icon"></i>
        </span>
    </button>
</template>

<script>
export default {
    name: 'ButtonWithLoadingState',
    props: {
        isStateLoading: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            required: true,
        },
        showIconAfterText: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
